import { EMPTY_STRING } from 'common/constants';
import getResponseError from './getResponseError';

const getTranslateIdFromResponseError = async (e: any): Promise<string> => {
  const { code } = await getResponseError(e);
  return code ? `error.${code}` : EMPTY_STRING;
};

export default getTranslateIdFromResponseError;
